import React, { forwardRef, ReactNode } from 'react';
import { Tooltip as ChakraTooltip, TooltipProps } from '@chakra-ui/react';

interface Props extends TooltipProps {
  children: ReactNode;
}

export const Tooltip = forwardRef<HTMLDivElement, Props>(
  (props, ref): JSX.Element => {
    return (
      <ChakraTooltip ref={ref} {...props}>
        {props.children}
      </ChakraTooltip>
    );
  }
);
export type { Props as TooltipProps };
